<div class="detalii-container d-flex flex-column">
    <span class="detalii-title">Înregistrare Programare</span>

    <app-navbar-programare [onContinua]="handleContinua"
        [continuaDisabled]="subcontracteLocale.length === 0"></app-navbar-programare>

    <div class="detalii-content d-flex gap-4">

        <!-- LEFT -->
        <div class="detalii-content-left">
            <form [formGroup]="infoForm">

                <!-- PERIOADA CONTRACTUALA -->
                <div class="detalii-section" [class.section--disabled]="disponibilitateActiva">
                    <span class="detalii-section__title">Perioada contractuală</span>
                    <div class="detalii-section__controls">
                        <button type="button" class="calendar-btn" [popover]="popTemplate" [adaptivePosition]="false"
                            container="body" placement="right top">
                            <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                            <span>{{ dateRangeLabel }}</span>
                        </button>
                        <div class="luni-buttons">
                            <button *ngFor="let luni of luniOptions" type="button" class="luni-btn"
                                [class.luni-btn--selected]="selectedLuni === luni" (click)="selectLuni(luni)">
                                {{ luni }} LUNI
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <mat-form-field class="col-md-6">
                            <mat-label>Nr. contract</mat-label>
                            <input type="text" matInput formControlName="nr_contract" />
                        </mat-form-field>
                        <mat-form-field class="col-md-6">
                            <mat-label>Dată contract</mat-label>
                            <input matInput [matDatepicker]="picker" formControlName="data_contract" readonly
                                (focus)="picker.open()">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="d-flex align-items-center justify-content-end" *ngIf="!isContractCreated">
                        <button type="button" class="disponibilitate-btn" [disabled]="!isPerioadaCompleted || isLoading"
                            (click)="createContract()">
                            CONTINUĂ
                        </button>
                    </div>

                    <ng-template #popTemplate>
                        <div class="calendar-popover">
                            <div class="calendar-popover__header">
                                <h2>Selectați intervalul</h2>
                                <button class="close-btn" (click)="closePopover()">
                                    <img src="assets/icons/close.svg" alt="Închide" /><span>ÎNCHIDE</span>
                                </button>
                            </div>
                            <div class="calendar-popover__body">
                                <div class="calendar-col">
                                    <div class="calendar-header">
                                        <div class="calendar-header__label">DE LA:</div>
                                        <div class="calendar-header__date">
                                            {{ selectedStartDate ? (selectedStartDate | date:'mediumDate') : '---' }}
                                        </div>
                                    </div>
                                    <mat-card>
                                        <mat-calendar #startCalendar [selected]="selectedStartDate"
                                            [startAt]="selectedStartDate ?? today" [minDate]="today"
                                            [maxDate]="selectedEndDate ?? undefined"
                                            (selectedChange)="onStartDateSelected($event)">
                                        </mat-calendar>
                                    </mat-card>
                                </div>
                                <div class="calendar-col">
                                    <div class="calendar-header">
                                        <div class="calendar-header__label">PÂNĂ LA:</div>
                                        <div class="calendar-header__date">
                                            {{ selectedEndDate ? (selectedEndDate | date:'mediumDate') : '---' }}
                                        </div>
                                    </div>
                                    <mat-card>
                                        <mat-calendar #endCalendar [selected]="selectedEndDate"
                                            [startAt]="selectedEndDate ?? selectedStartDate ?? today"
                                            [minDate]="selectedStartDate ?? today"
                                            (selectedChange)="onEndDateSelected($event)">
                                        </mat-calendar>
                                    </mat-card>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>

                <ng-container *ngIf="isContractCreated">
                    <!-- SPECIALIZARE -->
                    <div class="detalii-section" [class.section--disabled]="disponibilitateActiva">
                        <mat-form-field class="w-100">
                            <mat-label>Specializare</mat-label>
                            <mat-select formControlName="specializare_id" (openedChange)="onSpecializareSelectClosed()">
                                <mat-form-field class="px-2 w-100 sticky-input">
                                    <input matInput [formControl]="specializariControl"
                                        (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                </mat-form-field>
                                <mat-option *ngIf="filteredSpecializari.length === 0" disabled>
                                    No results found
                                </mat-option>
                                <mat-option [value]="-1">-- Alegeți --</mat-option>
                                <mat-option *ngFor="let s of filteredSpecializari" [value]="s.id">
                                    {{ s.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <!-- NR SEDINTE + FRECVENTA -->
                    <div class="detalii-section" [class.section--disabled]="disponibilitateActiva">
                        <mat-form-field class="w-100">
                            <mat-label>Nr. ședințe</mat-label>
                            <input type="number" matInput formControlName="nr_sedinte" />
                        </mat-form-field>
                        <div class="frecventa-row">
                            <span class="frecventa-row__label">Frecvență - vizite săptămânale / săptămână</span>
                            <div class="frecventa-row__buttons">
                                <button type="button" class="luni-btn frecventa-btn"
                                    [class.luni-btn--selected]="infoForm.get('frecventa_sedinte')?.value === 1"
                                    (click)="selectFrecventa(1)">1</button>
                                <button type="button" class="luni-btn frecventa-btn"
                                    [class.luni-btn--selected]="infoForm.get('frecventa_sedinte')?.value === 2"
                                    (click)="selectFrecventa(2)">2</button>
                            </div>
                        </div>
                    </div>

                    <!-- INTERVAL SEDINTE -->
                    <div class="detalii-section" [class.section--disabled]="disponibilitateActiva">
                        <span class="detalii-section__title">Interval ședințe</span>
                        <div class="detalii-section__controls">
                            <button type="button" class="calendar-btn" [popover]="intervalPopTemplate"
                                [adaptivePosition]="true" container="body" #intervalPopover="bs-popover"
                                [disabled]="preluareContract || disponibilitateActiva">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ intervalRangeLabel }}</span>
                            </button>
                            <label class="preluare-check">
                                <input type="checkbox" [(ngModel)]="preluareContract"
                                    [ngModelOptions]="{standalone: true}" (change)="onPreluareContractChange()" />
                                <span>Preluare din contract</span>
                            </label>
                        </div>
                        <div class="luni-buttons">
                            <button *ngFor="let luni of availableLuniOptions" type="button" class="luni-btn"
                                [class.luni-btn--selected]="intervalSelectedLuni === luni"
                                [disabled]="preluareContract || disponibilitateActiva"
                                (click)="selectIntervalLuni(luni)">
                                {{ luni }} LUNI
                            </button>
                        </div>

                        <ng-template #intervalPopTemplate>
                            <div class="calendar-popover">
                                <div class="calendar-popover__header">
                                    <h2>Selectați intervalul ședințelor</h2>
                                    <button class="close-btn" (click)="closeIntervalPopover()">
                                        <img src="assets/icons/close.svg" alt="Închide" /><span>ÎNCHIDE</span>
                                    </button>
                                </div>
                                <div class="calendar-popover__body">
                                    <div class="calendar-col">
                                        <div class="calendar-header">
                                            <div class="calendar-header__label">DE LA:</div>
                                            <div class="calendar-header__date">
                                                {{ intervalStartDate ? (intervalStartDate | date:'mediumDate') : '---'
                                                }}
                                            </div>
                                        </div>
                                        <mat-card>
                                            <mat-calendar #intervalStartCalendar [selected]="intervalStartDate"
                                                [startAt]="intervalStartDate ?? intervalMinStart"
                                                [minDate]="intervalMinStart"
                                                [maxDate]="intervalEndDate ?? intervalMaxEnd ?? undefined"
                                                (selectedChange)="onIntervalStartSelected($event)">
                                            </mat-calendar>
                                        </mat-card>
                                    </div>
                                    <div class="calendar-col">
                                        <div class="calendar-header">
                                            <div class="calendar-header__label">PÂNĂ LA:</div>
                                            <div class="calendar-header__date">
                                                {{ intervalEndDate ? (intervalEndDate | date:'mediumDate') : '---' }}
                                            </div>
                                        </div>
                                        <mat-card>
                                            <mat-calendar #intervalEndCalendar [selected]="intervalEndDate"
                                                [startAt]="intervalEndDate ?? intervalStartDate ?? intervalMinStart"
                                                [minDate]="intervalStartDate ?? intervalMinStart"
                                                [maxDate]="intervalMaxEnd ?? undefined"
                                                (selectedChange)="onIntervalEndSelected($event)">
                                            </mat-calendar>
                                        </mat-card>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>


                    <!-- PREFERINTE ORARE -->
                    <div class="detalii-section" [class.section--disabled]="disponibilitateActiva">
                        <span class="detalii-section__title">Preferințe orare</span>
                        <div class="preferinte-grid" [class.preferinte-grid--disabled]="noPreferinta">
                            <div class="preferinte-col" *ngFor="let zi of zile">
                                <span class="preferinte-col__label">{{ zi.label }}</span>
                                <button *ngFor="let interval of intervaleOrare" type="button" class="interval-btn"
                                    [class.interval-btn--selected]="isSlotSelected(zi.id, interval)"
                                    [disabled]="noPreferinta" (click)="toggleSlot(zi.id, interval)">
                                    {{ interval.start }} - {{ interval.end }}
                                </button>
                            </div>
                        </div>
                        <div class="preferinte-footer">
                            <label class="preluare-check">
                                <input type="checkbox" [(ngModel)]="noPreferinta" [ngModelOptions]="{standalone: true}"
                                    (change)="onNoPreferintaChange()" />
                                <span>Nu sunt preferințe orare</span>
                            </label>
                            <button *ngIf="!disponibilitateActiva" type="button" class="disponibilitate-btn"
                                [disabled]="infoForm.invalid" (click)="arataDisponibilitate()">
                                ARATĂ DISPONIBILITATE
                            </button>
                        </div>
                    </div>
                    <div class="preferinte-footer-extern" *ngIf="disponibilitateActiva">
                        <button type="button" class="anulare-disponibilitate-btn" (click)="anuleazaDisponibilitate()">
                            <mat-icon>cancel</mat-icon>
                            ANULEAZĂ
                        </button>
                    </div>
                </ng-container>
            </form>

            <app-disponibilitate-programare *ngIf="slotsData" [slotsResponse]="slotsData"
                [nrSedinte]="infoForm.getRawValue().nr_sedinte" [frecventa]="infoForm.getRawValue().frecventa_sedinte"
                [preselectii]="preselectiiEdit" [contractId]="contractId"
                [dateEndSedinte]="infoForm.getRawValue().date_end_sedinte"
                (confirmaSelectie)="handleConfirmaSelectie($event)" (selectiiChange)="onSelectiiChange($event)">
            </app-disponibilitate-programare>
        </div>

        <!-- RIGHT -->
        <div class="detalii-content-right">
            <div class="sumar-sticky-wrapper">

                <!-- SUMAR BENEFICIAR -->
                <div class="sumar-card">
                    <span class="sumar-card__title">Sumar contract</span>
                    <button type="button" class="draft-anulare-btn" (click)="handleAnulare()">
                        <mat-icon>delete_forever</mat-icon>
                        ANULEAZĂ CONTRACT
                    </button>
                    <div class="sumar-entitate" *ngIf="entitate">
                        <div class="sumar-entitate__header">
                            <mat-icon>person_outline</mat-icon>
                            <span class="sumar-entitate__name">{{ entitate.full_name }}</span>
                        </div>
                        <div class="sumar-entitate__details">
                            <div class="sumar-row" *ngIf="selectedStartDate && selectedEndDate">
                                <span class="sumar-row__label">Perioada contractuală:</span>
                                <span class="sumar-row__value">
                                    {{ selectedStartDate | date:'dd.MM.yyyy' }} - {{ selectedEndDate | date:'dd.MM.yyyy'
                                    }}
                                </span>
                            </div>
                            <div class="sumar-row">
                                <span class="sumar-row__label">CNP:</span>
                                <span class="sumar-row__value">{{ entitate.cnp }}</span>
                            </div>
                            <div class="sumar-row" *ngIf="entitate.tutore_relationships.length > 0">
                                <span class="sumar-row__label">Tutore:</span>
                                <span class="sumar-row__value">
                                    {{ entitate.tutore_relationships[0].related_entity_name }}
                                </span>
                            </div>
                            <div class="sumar-row" *ngIf="entitate.current_address">
                                <span class="sumar-row__label">Adresă:</span>
                                <span class="sumar-row__value">{{ entitate.current_address.formatted_address }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- SUBCONTRACTE -->
                <ng-container *ngIf="subcontracteLocale.length > 0">
                    <div class="subcontracte-section">
                        <span class="subcontracte-section__title">Programări contractuale</span>

                        <div class="edit-banner" *ngIf="editingSubcontractId !== null">
                            <mat-icon>edit</mat-icon>
                            <span>Modifici un subcontract existent</span>
                            <button type="button" class="cancel-edit-btn" (click)="cancelEdit()">
                                <mat-icon>close</mat-icon>
                                ANULEAZĂ
                            </button>
                        </div>

                        <ng-container *ngFor="let sub of subcontracteLocale">
                            <div class="subcontract-card"
                                *ngIf="editingSubcontractId === null || editingSubcontractId === sub.subcontract_id"
                                [class.subcontract-card--editing]="editingSubcontractId === sub.subcontract_id">

                                <div class="subcontract-card__header">
                                    <div class="subcontract-card__header-left">
                                        <mat-icon>medical_services</mat-icon>
                                        <span class="subcontract-card__specializare">{{ sub.specializare_name }}</span>
                                    </div>
                                    <div class="subcontract-card__actions">
                                        <button type="button" class="sc-action-btn sc-action-btn--edit"
                                            [disabled]="editingSubcontractId !== null" (click)="editSubcontract(sub)"
                                            matTooltip="Editează">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                        <button type="button" class="sc-action-btn sc-action-btn--delete"
                                            [disabled]="editingSubcontractId !== null" (click)="deleteSubcontract(sub)"
                                            matTooltip="Șterge">
                                            <mat-icon>delete_outline</mat-icon>
                                        </button>
                                    </div>
                                </div>

                                <div class="subcontract-card__meta">
                                    <div class="sc-meta-row">
                                        <span class="sc-meta-label">Interval:</span>
                                        <span class="sc-meta-value">
                                            {{ sub.date_from_sedinte | date:'dd.MM.yyyy' }} – {{ sub.date_end_sedinte |
                                            date:'dd.MM.yyyy' }}
                                        </span>
                                    </div>
                                    <div class="sc-meta-row">
                                        <span class="sc-meta-label">Nr. ședințe:</span>
                                        <span class="sc-meta-value">{{ sub.nr_sedinte }}</span>
                                    </div>
                                    <div class="sc-meta-row">
                                        <span class="sc-meta-label">Frecvență:</span>
                                        <span class="sc-meta-value">{{ sub.frecventa_sedinte }} / săpt.</span>
                                    </div>
                                </div>

                                <ng-container *ngFor="let specialist of getSpecialistiDinSubcontract(sub)">
                                    <div class="sc-specialist-block">
                                        <div class="sc-specialist-header">
                                            <mat-icon>person_outline</mat-icon>
                                            <span>{{ specialist.nume }}</span>
                                        </div>
                                        <div class="sc-programari-grid">
                                            <div class="sc-programare-chip" *ngFor="let slot of specialist.slots">
                                                <span class="sc-chip-dow">{{ getDayOfWeekRo(slot.date) }}</span>
                                                <span class="sc-chip-date">{{ slot.date | date:'dd.MM.yyyy' }}</span>
                                                <span class="sc-chip-time">{{ formatSlotTime(slot) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>

    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>